import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang } = useGlobal();
    const { t } = useLang('camp');
    const lists: any[] = [
        {
            title: t('secG_list1_title'),
            desc: t('secG_list1_desc'),
        },
        {
            title: t('secG_list2_title'),
            desc: t('secG_list2_desc'),
        },
        {
            title: t('secG_list3_title'),
            desc: t('secG_list3_desc'),
        },
        {
            title: t('secG_list4_title'),
            desc: t('secG_list4_desc'),
        },
        {
            title: t('secG_list5_title'),
            desc: t('secG_list5_desc'),
        },
    ];
    return (
        <div id="camp-G" className={`camp-G camp-box ${css['camp-G']}`}>
            <h2 className="title">{t('secG_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/7.jpg'} alt={t('secG_title')} />
            </div>
            <p className="desc">{t('secG_desc')}</p>
            <ul className="lists">
                {lists?.map((list: any, k: number) => (
                    <li className="list" key={k}>
                        <h3 className="list-title">{list?.title}</h3>
                        <p className="list-desc desc">{list?.desc}</p>
                    </li>
                ))}
            </ul>
            <p className="desc memo">{t('secG_memo')}</p>
        </div>
    );
}
